import { createError } from '@common/neo.tax';
import { useParams } from 'react-router-dom';

// convenient company ID getter
export const useCurrentCompanyId = (): string => {
  const { companyId } = useParams();
  if (!companyId) {
    throw createError('UseCurrentCompanyIdError', 'Empty company id when using useCurrentCompanyId hook');
  }
  return companyId;
};

// Only use this in /companies route where company id is not required
export const useCurrentCompanyIdOptional = (): string | null => {
  const { companyId } = useParams();
  return companyId ?? null;
};
